import { default as IndexBarElement } from "./index-list.js";
import IndexListAnchor from "./index-list-anchor.js";
const IndexList = IndexBarElement;
IndexList.Anchor = IndexListAnchor;
export default IndexList;
